import { Observable } from "rxjs/internal/Observable";
import { requestAlertaDocumento } from "./request/alerta_documento.request";
import { AlertaDocumentoResponse } from "./response/alerta_documento.response";

export abstract class AlertaDocumentoRepository{
  abstract listarAlertaDocumento( fd : requestAlertaDocumento):Observable<AlertaDocumentoResponse>;
}
